import { createInMemoryCache } from '@algolia/cache-in-memory';
import recommend from '@algolia/recommend';
import { APPLICATION_ID, SEARCH_API_KEY } from './searchClient';

export const recommendClient = recommend(APPLICATION_ID, SEARCH_API_KEY, {
  responsesCache: createInMemoryCache(),
  requestsCache: createInMemoryCache({ serializable: false }),
});
